import React from 'react'
import {
  FilledInputProps,
  InputLabelProps,
  InputProps,
  OutlinedInputProps,
  TextField,
} from '@mui/material'
import { Controller } from 'react-hook-form'
import { RegisterOptions } from 'react-hook-form/dist/types/validator'
import { UseFormReturn } from 'react-hook-form/dist/types'

interface FormTextFieldProps {
  useForm: UseFormReturn<any>
  inputLabelProps?: Partial<InputLabelProps>
  inputProps?:
    | Partial<InputProps>
    | Partial<FilledInputProps>
    | Partial<OutlinedInputProps>
  label: string
  name: string
  rules?: Omit<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >
  type?: React.InputHTMLAttributes<unknown>['type']
  multiLine?: boolean
  autoFocus?: boolean
  disabled?: boolean
  required?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const getError = (errors: any, name: string) => {
  const properties = name.split('.')
  return properties.reduce((prev, curr) => prev && prev[curr], errors)
}

const FormTextField = ({
  useForm,
  autoFocus,
  multiLine,
  inputProps,
  inputLabelProps,
  label,
  name,
  rules,
  type,
  disabled,
  required,
  onChange,
}: FormTextFieldProps) => {
  const error = getError(useForm.formState.errors, name)

  const passChange = !onChange ? {} : { onChange: onChange }

  return (
    <Controller
      name={name as `${string}`}
      control={useForm.control}
      rules={rules}
      render={({ field }) => (
        <TextField
          {...field}
          {...passChange}
          autoFocus={autoFocus != null && autoFocus}
          multiline={multiLine != null && multiLine}
          error={error != null}
          InputLabelProps={inputLabelProps}
          InputProps={inputProps}
          label={
            error == null
              ? label
              : `${label} is ${useForm.formState.errors[name]!.type}`
          }
          size="small"
          type={type}
          disabled={disabled}
          required={required}
        />
      )}
    />
  )
}

export default FormTextField
